/**
 * Index file for Algolia Facets Alpine Plugin
 */

import Alpine from 'alpinejs';
import AlpineMorph from '@alpinejs/morph';
import AlgoliaFacetsPlugin from '../js/algolia-facets-alpine';
import collapse from '@alpinejs/collapse'
import splideSlider from '../components/splideslider';
import ketoCalculator from '../components/calculators';
import initAccordion from '../components/accordion';
import '../components/footer.js';
import '../components/klaviyo.js';
import '../components/sorting.js';
import '../components/view.js';
import '../components/post.js';
import '../components/gravity-form.js';
import SearchProducts from '../js/search-products';

window.Alpine = Alpine

// Register the plugin with Alpine
Alpine.plugin(AlpineMorph);
Alpine.plugin(AlgoliaFacetsPlugin);
Alpine.plugin(collapse);
Alpine.plugin(SearchProducts);

Alpine.data('splideSlider', splideSlider);
Alpine.data('ketoCalculator', ketoCalculator);

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
	initAccordion();
});

// Export Alpine for use in other files
export default Alpine;
